<template>
  <div class="keep-alive">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!--不缓存的视图-->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <template></template>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
export default {
  data() {
    return {
      list: [
        {
          name: '报销单查询',
          url: '/fire/reimbursementModuleIndex/billSearchIndex/reimbursementSearch'
        },
        // {
        //   name: '预审批单查询',
        //   url: '/fire/reimbursementModuleIndex/billSearchIndex/preliminarySearch'
        // },
      ]
    }
  },
  
  mounted() {
    config()
    this.$nextTick(() => {
      this.$bus.emit('isShowTopMenu', true)
      this.$bus.emit('getTopMenuList', this.list)
    })
  }
};
</script>
<style lang='scss' scoped>
.keep-alive {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>